// v0.4.7+: forum src 2.0 化 (辉哥 2026-07-20 21:38 拍板, 砍 1.8 兼容)
//   - LinkButton 改 `flarum/common/components/LinkButton` (2.0 vendor namespace)
//   - IndexPage 保持 `flarum/forum/components/IndexPage` (2.0 vendor 实际 namespace)
//   - app 保持 `flarum/forum/app` (2.0 vendor 实际 namespace, 跟 forum 端组件配对)
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import LinkButton from 'flarum/common/components/LinkButton';
export default function () {
  extend(IndexPage.prototype, 'navItems', function (items) {
    var _app$session;
    if ((_app$session = app.session) != null && _app$session.user && app.forum.attribute('seedreamAllowUse')) {
      items.add('dressUp', m(LinkButton, {
        icon: "fas fa-magic",
        href: app.route('dressUp')
      }, app.translator.trans('图片融合')), 15);
      return items;
    }
  });
}